import React, { useEffect } from 'react';

/**
 * ScrollTop - Scroll to top arrow button
 * Exact implementation from original theme
 */
function ScrollTop() {
  useEffect(() => {
    // Show/hide scroll top arrow based on scroll position
    const handleScroll = () => {
      const scrollTopArrow = document.querySelector('.scroll-top-arrow');
      if (scrollTopArrow) {
        if (window.scrollY >= 100) {
          scrollTopArrow.classList.add('show');
        } else {
          scrollTopArrow.classList.remove('show');
        }
      }
    };

    // Scroll to top when clicked
    const scrollToTop = (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    // Add event listeners
    window.addEventListener('scroll', handleScroll);
    
    const scrollTopArrow = document.querySelector('.scroll-top-arrow');
    if (scrollTopArrow) {
      scrollTopArrow.addEventListener('click', scrollToTop);
    }

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTopArrow) {
        scrollTopArrow.removeEventListener('click', scrollToTop);
      }
    };
  }, []);

  return (
    <a className="scroll-top-arrow" href="javascript:void(0);">
      <i className="fa fa-angle-up"></i>
    </a>
  );
}

export default ScrollTop;